import callApiPromise from "helpers/call-api-promise";

export const purchasePrepaidBalanceRequestData = {
    purchase_prepaid_balance_cents: 0,
    stripe_token: null,
    save_card: false
};

export const purchasePrepaidBalanceMutation = ({ requestData }) =>
    callApiPromise({
        endpoint: "/user/prepaid/purchase/",
        method: "POST",
        data: requestData
    })();
